module.exports = __webpack_public_path__ + "media/images/patent/x_7-094b2a069b750ab4189e92ec5a8b1c72.png";